var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclecheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#00BF99"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.426 16.0033L8.5 17.8801L12.2953 21.6101C13.2549 22.5533 14.7889 22.5678 15.7662 21.6428L24.5 13.3767L22.574 11.5L14.015 19.5591L10.426 16.0033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclecheck);
export default __webpack_public_path__ + "static/media/circlecheck.de18b7da261a9d9ccb3e86fdb6db1029.svg";
export { ForwardRef as ReactComponent };